import { env } from '@/config/env'

/**
 * WhatsApp deep link with an optional pre-filled message.
 *
 * Unlike m.me, wa.me carries the message text through — so what the shopper
 * typed in the on-page chat widget lands in the WhatsApp composer verbatim.
 *
 * The number is the store's `whatsappNumber` setting: digits only with country
 * code and no '+', which is exactly the wa.me format. Callers should pass it
 * from `useSettings()`; the env default only prevents `wa.me/undefined` when
 * called bare.
 *
 * @param {string} [message]
 * @param {string} [phone]
 */
export function whatsAppUrl(message = '', phone = env.whatsappNumber) {
  const base = `https://wa.me/${String(phone).replace(/\D/g, '')}`
  return message ? `${base}?text=${encodeURIComponent(message)}` : base
}
